function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createSlots as _createSlots } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  key: 1,
  "data-cy": "cardHeader"
};
var _hoisted_3 = {
  class: "spaced-between-row"
};
var _hoisted_4 = {
  class: "flex-started-row header-toggle-section"
};
var _hoisted_5 = ["title"];
var _hoisted_6 = {
  class: "flex-started-row"
};
var _hoisted_7 = {
  class: "card-summary me-3"
};
var _hoisted_8 = {
  key: 0,
  class: "me-3"
};
var _hoisted_9 = {
  key: 1,
  class: "icon-chevron",
  width: "12",
  height: "9",
  viewBox: "0 0 12 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_10 = {
  key: 2,
  class: "icon-chevron",
  width: "12",
  height: "9",
  viewBox: "0 0 12 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_11 = {
  key: 1,
  class: "cardDescription"
};
var _hoisted_12 = {
  class: "flex-started-row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_b_col = _resolveComponent("b-col");
  var _component_b_row = _resolveComponent("b-row");
  var _component_b_button = _resolveComponent("b-button");
  var _component_b_card = _resolveComponent("b-card");
  var _directive_b_tooltip = _resolveDirective("b-tooltip");
  return _openBlock(), _createBlock(_component_b_card, {
    class: _normalizeClass(["ifas-card", $props.isProcessStep && !$props.visible ? 'hidden-card' : '']),
    "header-class": $props.cardHeaderClass,
    "body-class": $props.cardBodyClass
  }, _createSlots({
    default: _withCtx(function () {
      return [_renderSlot(_ctx.$slots, "default", {}, undefined, true)];
    }),
    _: 2 /* DYNAMIC */
  }, [!$props.noHeader ? {
    name: "header",
    fn: _withCtx(function () {
      return [!$props.nonCollapsible ? (_openBlock(), _createBlock(_component_b_button, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $props.toggleCollapse && $props.toggleCollapse($props.cardId);
        }),
        class: "collapseToggleButton",
        variant: null
      }, {
        default: _withCtx(function () {
          return [$options.hasHeaderSlot ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "header", {}, function () {
            return [$props.header ? (_openBlock(), _createElementBlock("h4", {
              key: 0,
              class: _normalizeClass($props.typeOfHeader == 'summaryHeader' ? 'mb-0 summaryHeader' : $props.typeOfHeader == 'householdHeader' ? 'mb-0 householdHeader' : 'mb-0 ifas-card-header-h5')
            }, _toDisplayString($props.header), 3 /* TEXT, CLASS */)) : _createCommentVNode("v-if", true)];
          }, true)])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "icon", {}, undefined, true), _createElementVNode("div", {
            class: _normalizeClass($props.typeOfHeader == 'summaryHeader' ? 'summaryHeader' : $props.typeOfHeader == 'householdHeader' ? 'householdHeader' : 'ms-2')
          }, [_createElementVNode("div", {
            class: _normalizeClass(["centeredHeaderText", {
              'mr-auto': $options.hasButtons
            }])
          }, [_withDirectives((_openBlock(), _createElementBlock("span", {
            class: "ms-1",
            title: $props.tooltip
          }, [$props.header ? (_openBlock(), _createElementBlock("h4", {
            key: 0,
            class: _normalizeClass($props.typeOfHeader == 'summaryHeader' ? 'mb-0 summaryHeader' : $props.typeOfHeader == 'householdHeader' ? 'mb-0 householdHeader' : 'mb-0 ifas-card-header-h5')
          }, _toDisplayString($props.header), 3 /* TEXT, CLASS */)) : _createCommentVNode("v-if", true), _renderSlot(_ctx.$slots, "title", {}, undefined, true)], 8 /* PROPS */, _hoisted_5)), [[_directive_b_tooltip, void 0, void 0, {
            hover: true,
            right: true
          }]])], 2 /* CLASS */)], 2 /* CLASS */), _createCommentVNode(" <div class=\"ms-3\" v-if=\"!hasButtons && (cardDescription || hasCardDescription)\">\r\n                                <slot v-if=\"hasCardDescription\" name=\"cardDescription\"></slot>\r\n                                <span v-if=\"cardDescription\" class=\"cardDescription centeredHeaderText\">{{ cardDescription }}</span>\r\n                            </div> ")]), _createElementVNode("div", null, [_renderSlot(_ctx.$slots, "collapseToggleButton", {}, function () {
            return [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString($options.stringifySummaryItems), 1 /* TEXT */), $options.hasButtons ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_renderSlot(_ctx.$slots, "buttons", {}, undefined, true)])) : _createCommentVNode("v-if", true), $props.collapsed ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _toConsumableArray(_cache[1] || (_cache[1] = [_createElementVNode("path", {
              d: "M6 9L0.803849 -9.78799e-07L11.1962 -7.02746e-08L6 9Z"
            }, null, -1 /* CACHED */)])))) : (_openBlock(), _createElementBlock("svg", _hoisted_10, _toConsumableArray(_cache[2] || (_cache[2] = [_createElementVNode("path", {
              d: "M6 0L11.1962 9L0.803848 9L6 0Z"
            }, null, -1 /* CACHED */)]))))])];
          }, true)])]), $options.hasButtons && $props.cardDescription ? (_openBlock(), _createBlock(_component_b_row, {
            key: 0
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_b_col, null, {
                default: _withCtx(function () {
                  return [$options.hasCardDescription ? _renderSlot(_ctx.$slots, "cardDescription", {
                    key: 0
                  }, undefined, true) : _createCommentVNode("v-if", true), $props.cardDescription ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($props.cardDescription), 1 /* TEXT */)) : _createCommentVNode("v-if", true)];
                }),
                _: 3 /* FORWARDED */
              })];
            }),
            _: 3 /* FORWARDED */
          })) : _createCommentVNode("v-if", true)]))];
        }),
        _: 3 /* FORWARDED */
      })) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["centeredHeaderText ms-1", {
          'mr-auto': $options.hasButtons
        }])
      }, [_createElementVNode("div", _hoisted_12, [_renderSlot(_ctx.$slots, "icon", {}, undefined, true), _createElementVNode("div", {
        class: _normalizeClass(["centeredHeaderText ms-1", {
          'mr-auto': $options.hasButtons
        }])
      }, [_renderSlot(_ctx.$slots, "header", {}, function () {
        return [$props.header ? (_openBlock(), _createElementBlock("h4", {
          key: 0,
          class: _normalizeClass($props.typeOfHeader == 'summaryHeader' ? 'mb-0 summaryHeader' : $props.typeOfHeader == 'householdHeader' ? 'mb-0 householdHeader' : 'mb-0 ifas-card-header-h5')
        }, _toDisplayString($props.header), 3 /* TEXT, CLASS */)) : _createCommentVNode("v-if", true)];
      }, true)], 2 /* CLASS */)])], 2 /* CLASS */))];
    }),
    key: "0"
  } : undefined, $options.hasFooterSlot ? {
    name: "footer",
    fn: _withCtx(function () {
      return [_renderSlot(_ctx.$slots, "footer", {}, undefined, true)];
    }),
    key: "1"
  } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "header-class", "body-class"]);
}